import { render, staticRenderFns } from "./LocalDataTable.vue?vue&type=template&id=43595aad"
import script from "./LocalDataTable.vue?vue&type=script&lang=ts"
export * from "./LocalDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports